import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MapLayerService {
  API_SERVER: string = environment.baseApiUrl;
  reloadTable$ = new BehaviorSubject(false);
  timelineMaplayer$ = new BehaviorSubject([]);

  constructor(private httpClient: HttpClient) {}

  findAll(params?): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach((elem) => {
        Params = Params.append(elem.key, elem.val);
      });
    }
    return this.httpClient.get(this.API_SERVER + 'map-layer', {
      params: Params,
    });
  }

  findOne(id): Observable<any> {
    return this.httpClient.get(this.API_SERVER + `map-layer/${id}`);
  }

  create(data): Observable<any> {
    return this.httpClient.post(this.API_SERVER + 'map-layer', data);
  }

  update(id, data): Observable<any> {
    return this.httpClient.put(this.API_SERVER + `map-layer/${id}`, data);
  }

  updateStyle(id, data): Observable<any> {
    return this.httpClient.put(
      this.API_SERVER + `map-layer/update-style/${id}`,
      data
    );
  }

  remove(id): Observable<any> {
    return this.httpClient.delete(this.API_SERVER + `map-layer/${id}`);
  }

  restore(id): Observable<any> {
    return this.httpClient.delete(this.API_SERVER + `map-layer/restore/${id}`);
  }

  findTimeline(id): Observable<any> {
    return this.httpClient.get(
      this.API_SERVER + `map-layer/timeline?locationId=${id}`
    );
  }

  getMapLayerTimeline(currLocId) {
    this.findTimeline(currLocId).subscribe((res) => {
      const map_layers = res.map((i) => {
        i.map_layers.map((ml) => {
          ml.layer_date = i.date;
          switch (ml.layer_type) {
            case 'thermal':
              ml.layer_icon = 'icon-thermal';
              break;

            case '3d-mesh':
            case '3d':
              ml.layer_icon = 'icon-d-mesh';
              break;

            case 'embed':
            case 'geojson':
              ml.layer_icon = 'icon-annotation-box-2';
              break;

            default:
              ml.layer_icon = 'icon-ortho';
              break;
          }
        });

        return i;
      });

      this.timelineMaplayer$.next(map_layers);
    });
  }
}
